<template>
  <div class="shift-handover-record-page nx-list-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button v-if="hasPermission('shift_handover_record_add')" type="primary" size="small" icon="el-icon-plus" @click="openAdd">
          新增
        </el-button>
        <el-button
          v-if="hasPermission('shift_handover_record_export')"
          type="primary"
          plain
          size="small"
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >
          导出
        </el-button>
      </template>
      <template #menu="{ size, row }">
        <el-button v-if="hasPermission('shift_handover_record_view')" type="text" :size="size" @click="openDetail(row)">查看</el-button>
        <el-button v-if="hasPermission('shift_handover_record_edit')" type="text" :size="size" @click="openEdit(row)">编辑</el-button>
        <el-button v-if="hasPermission('shift_handover_record_delete')" type="text" :size="size" class="menu-btn-delete" @click="handleRemove(row)">删除</el-button>
      </template>
    </avue-crud>

    <handover-form-dialog
      :visible.sync="formVisible"
      :mode="formMode"
      :record-id="currentId"
      :team-options="teamOptions"
      @success="refresh"
    />
    <handover-detail-dialog :visible.sync="detailVisible" :record-id="currentId" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import crudMixins from "@/mixins/crud-mixins";
import { downloadXls } from "@/util/util";
import { exportExcel, getList, getShiftListByTeam, getTeamDict, remove } from "./api";
import HandoverFormDialog from "./components/HandoverFormDialog.vue";
import HandoverDetailDialog from "./components/HandoverDetailDialog.vue";

export default {
  name: "ShiftHandoverRecord",
  mixins: [crudMixins],
  components: {
    HandoverFormDialog,
    HandoverDetailDialog,
  },
  data() {
    return {
      apiConfig: { getList },
      exportLoading: false,
      teamOptions: [],
      queryShiftOptions: [],
      formVisible: false,
      detailVisible: false,
      formMode: "add",
      currentId: "",
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        selection: false,
        menuWidth: 170,
        column: [
          {
            label: "日期",
            prop: "recordDateRange",
            type: "daterange",
            search: true,
            hide: true,
            display: false,
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            paramsKey: ["startDate", "endDate"],
            searchSpan: 8,
          },
          {
            label: "班组",
            prop: "teamNo",
            type: "select",
            search: true,
            hide: true,
            display: false,
            dicData: [],
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            change: (value) => this.handleQueryTeamChange(this.getAvueChangeValue(value)),
          },
          {
            label: "班次",
            prop: "shiftNo",
            type: "select",
            search: true,
            hide: true,
            display: false,
            dicData: [],
            props: {
              label: "shiftName",
              value: "shiftNo",
            },
          },
          {
            label: "日期",
            prop: "recordDate",
            minWidth: 120,
          },
          {
            label: "班组",
            prop: "teamName",
            minWidth: 130,
          },
          {
            label: "班次",
            prop: "shiftName",
            minWidth: 110,
          },
          {
            label: "记录人",
            prop: "recordUserName",
            search: true,
            minWidth: 120,
            maxlength: 100,
          },
          {
            label: "作业车列数",
            prop: "workTrainCount",
            minWidth: 110,
            align: "right",
          },
          {
            label: "作业车节数",
            prop: "workCarCount",
            minWidth: 110,
            align: "right",
          },
          {
            label: "中卫热电卸煤量",
            prop: "thermalPowerUnloadWeight",
            minWidth: 150,
            align: "right",
          },
          {
            label: "煤棚卸煤量",
            prop: "coalShedUnloadWeight",
            minWidth: 130,
            align: "right",
          },
          {
            label: "明细条数",
            prop: "itemCount",
            minWidth: 100,
            align: "right",
          },
          {
            label: "创建时间",
            prop: "createTime",
            minWidth: 165,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  mounted() {
    this.loadTeamOptions();
  },
  methods: {
    hasPermission(code) {
      const permission = this.permission || {};
      const value = permission[code];
      return value === true || value === 1 || value === "1" || value === "true";
    },
    setColumnDicData(prop, dicData) {
      const column = this.option.column.find((item) => item.prop === prop);
      if (column) {
        this.$set(column, "dicData", dicData || []);
      }
    },
    getAvueChangeValue(value) {
      return value && typeof value === "object" && Object.prototype.hasOwnProperty.call(value, "value") ? value.value : value;
    },
    async loadTeamOptions() {
      const res = await getTeamDict();
      this.teamOptions = (res.data && res.data.data) || [];
      this.setColumnDicData("teamNo", this.teamOptions);
    },
    async loadQueryShiftOptions(teamNo) {
      if (!teamNo) {
        this.queryShiftOptions = [];
        return;
      }
      const res = await getShiftListByTeam(teamNo);
      this.queryShiftOptions = (res.data && res.data.data) || [];
      this.setColumnDicData("shiftNo", this.queryShiftOptions);
    },
    handleQueryTeamChange(teamNo) {
      this.query.shiftNo = "";
      this.loadQueryShiftOptions(teamNo);
    },
    resetSearch() {
      this.queryShiftOptions = [];
      this.setColumnDicData("shiftNo", []);
      crudMixins.methods.searchReset.call(this);
    },
    refresh() {
      this.onLoad(this.page, this.query);
    },
    openAdd() {
      this.formMode = "add";
      this.currentId = "";
      this.formVisible = true;
    },
    openEdit(row) {
      this.formMode = "edit";
      this.currentId = row.id;
      this.formVisible = true;
    },
    openDetail(row) {
      this.currentId = row.id;
      this.detailVisible = true;
    },
    handleRemove(row) {
      this.$confirm("确认删除该交接班记录？", "提示", { type: "warning" })
        .then(() => remove(row.id))
        .then(() => {
          this.$message.success("删除成功");
          this.refresh();
        })
        .catch(() => {});
    },
    async handleExport() {
      if ((this.page.total || 0) < 1) {
        this.$message.warning("无数据可导出");
        return;
      }
      this.exportLoading = true;
      try {
        const res = await exportExcel(this.formatParams({ ...this.query }));
        downloadXls(res.data, `交接班记录_${Date.now()}.xlsx`);
        this.$message.success("导出成功");
      } catch (e) {
        this.$message.error("导出失败");
      } finally {
        this.exportLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.shift-handover-record-page {
  .menu-btn-delete.el-button--text {
    color: #f56c6c;
    &:hover {
      color: #f78989;
    }
  }
}
</style>
